import { FC } from "react";
import { VacanciesList } from "./VacanciesList";

export const VacanciesListPage: FC = () => {
    return (
        <div className="min-h-96 p-2 pt-4 sm:p-8">
            <h1 className="text-center text-3xl sm:text-4xl pb-4 font-semibold">Наши вакансии</h1>
            <VacanciesList />
        </div>
    )
}

export default VacanciesListPage;